<template>
  <div class="pay-for-success">
    <div class="success-img">
        <img src="../../assets/images/zhifuchenggong.png" alt="">
    </div>
    <div class="success-text">支付成功</div>
    <div class="to-study" @click="toStudy">去学习</div>
    <div class="to-study-tips">点击“去学习”按钮，即可查看该课程整套视频</div>
  </div>
</template>

<script>
export default {
  name: 'payForSuccess',
  data(){
      return{

      }
  },
  methods:{
      toStudy(){
          console.log('跳转到已购课程页面')
        //判断当前页面是否在小程序环境中,若在小程序中进行跳转
        wx.miniProgram.redirectTo({url:"../../switchPage?into=0&flag=normal"});
            // function goMiniProgrom(page){
            //     var ua = window.navigator.userAgent.toLowerCase();
            //     if(ua.match(/MicroMessenger/i) == 'micromessenger'){
            //         wx.miniProgram.getEnv(function(res) {
            //             if(res.miniprogram)
            //                 wx.miniProgram.navigateTo({url:page});
            //         });
            //     }
            // }
      }
  },
  created(){
    document.title = "支付详情";
  },
}
</script>
<style lang="scss" scoped>
    html,body{
        margin:0;
        padding:0;
        width: 100%;
        height: 100%;
        background: #F8F8F8;
    }
    .pay-for-success{
        width: 100%;
        height: 100%;
        // background: #F8F8F8;
        .success-img{
            width: 163px;
            height: 150px;
            padding-top: 84px;
            margin:0 auto;
            img{
                width: 163px;
                height: 150px;
            }
        }
        .success-text{
            width: 56px;
            height: 20px;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #666666;
            line-height: 20px;
            margin:0 auto;
            padding-top: 14px;
            padding-bottom: 121px;
        }
        .to-study{
            width: 299px;
            height: 49px;
            background: linear-gradient(315deg, #FF6060 0%, #FB6460 100%);
            border-radius: 25px;
            margin:0 auto;
            line-height: 49px;
            font-size: 16px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #FFFFFF;
        }
        .to-study-tips{
            width: 255px;
            height: 17px;
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #666666;
            line-height: 17px;
            margin:0 auto;
            padding-top: 11px;
        }
    }
</style>
